import { http } from '@utils/index';

const getOptions = () => {
	return http.get<OptionsRes>(`/sa/options`);
};
export default getOptions;
